'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var INITIALIZE_FORM = exports.INITIALIZE_FORM = 'AOR/INITIALIZE_FORM';

var initializeForm = exports.initializeForm = function initializeForm(initialValues) {
    return {
        type: INITIALIZE_FORM,
        payload: initialValues
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/admin-on-rest/lib/actions/formActions.js
// module id = 264
// module chunks = 0